export class LevelOfDevelopment{
  id : number;
  code : string;
  name : string;
}
